




"use strict";

import SliderNav from './components/slide-nav';
import CheckoutForm from './components/checkout-form';
import FaqOverview from './components/faq-overview';
import TipOverview from "./components/tip-overview";
import SearchTabs from './components/search-tabs';
import WerkgebiedTable from './components/werkgebied-table';
import EenmaligOnderhoudForm from './components/eenmalig-onderhoud-form';
import Overlay from './components/overlay';
import TableToggle from './components/table-toggle';
import DirectFileUpload from './components/direct-file-upload';
import setupOnderhoudForm from './components/onderhoud-form';
import { ecomEvent } from './components/datalayer';

DirectFileUpload();


document.addEventListener('DOMContentLoaded', setupOnderhoudForm);


// Fix Tawk message
if ( window.Tawk_API === undefined ) {
    window.Tawk_API = {};
}





//const thermoSection = document.querySelector('.show_thermo');
//if ( thermoSection ) {
//    const thermoPrevSection = thermoSection.parentElement.previousSibling;
//
//    const strContainsJa = str => /ja/gi.test(str);
//    const toggleThermometer = input => {
//        if ( strContainsJa(input.value) ) {
//            thermoSection.classList.add('thermo-visible');
//        } else {
//            thermoSection.classList.remove('thermo-visible');
//        }
//    };
//
//    /*
//    document.querySelectorAll('.gform_wrapper .thermometer_radio .ginput_container_radio input')
//        .forEach(input => {
//            input.addEventListener('change', evt => toggleThermometer(evt.currentTarget));
//            if ( strContainsJa(input.value) && input.checked ) {
//                input.closest('.thermometer_radio').classList.add('thermo-visible');
//            }
//        });
//        */
//
//
//    thermoPrevSection.querySelectorAll('input')
//        .forEach(input => {
//            input.addEventListener('change', evt => toggleThermometer(evt.currentTarget));
//            if ( strContainsJa(input.value) && input.checked ) {
//                thermoSection.classList.add('thermo-visible');
//            }
//        });
//}




















class OfferteSidebar {
    constructor (sidebar) {
        if ( !sidebar ) {
            return null;
        }

        this.sidebar = sidebar;

        this.dlEvent = ecomEvent();

        this.zonderZorgen = false;
        const installatieRadio = document.querySelector('.installatie_radio input[type="radio"][value="Installatie ZonderZorgen"');
        if ( installatieRadio && installatieRadio.checked && installatieRadio.getAttribute('checked') === 'checked' ) {
            this.zonderZorgen = true;
        }

        this.totalItems = document.querySelector('.offerte_sidebar .items');
        this.boilers = document.querySelectorAll('.boiler-selection')
        this.newThermo = false;
        this.thermo = {};
        this.totalPrice = 0;

        const thermoInput = document.querySelector('.field-section.Thermostaten input[type="text"]');
        if ( thermoInput ) {
            const value = thermoInput.value;
            const thermo = document.querySelector(`.thermo-options input[value="${value}"]`);
            if (thermo) {
                thermo.checked = true;
            }
        }

        this.update();
        this.addEvents();

        // Only fire on first page of form
        const firstPage = document.querySelector('.gf_step_active.gf_step_first');
        if (firstPage) {
            this.dlEvent?.push({ event: 'ecom_postcode_validation_step' }, false);
        }
    }

    calcTotal() {
        this.dlEvent?.resetProducts();
        this.boilers.forEach(boiler => {
            let iTotal = 0;
            const boilerId = boiler.value;
            const boilerName = boiler.name;
            const baseProduct = { item_brand: boiler.dataset.brand, item_category: "CV-Ketels" };
            const price = parseInt(boiler.dataset.price);
            const priceWithContract = parseInt(boiler.dataset.priceWithContract);
            const contractDiscount = price - priceWithContract;

            if (this.zonderZorgen) {
                iTotal += priceWithContract;
                this.dlEvent?.addProduct(boilerName, boilerId, priceWithContract, 1, { ...baseProduct, discount: contractDiscount });
            } else {
                iTotal += price;
                this.dlEvent?.addProduct(boilerName, boilerId, price, 1, baseProduct);
            }

            if (this.thermo.price) {
                iTotal += parseInt(this.thermo.price);
                this.dlEvent?.addProduct(this.thermo.name, this.thermo.id, parseInt(this.thermo.price), 1, { item_brand: this.thermo.brand, item_category: "Thermostaten" });
            }

            document.querySelector(`.boiler[data-boilerid="${boilerId}"] .total`).innerHTML = iTotal;
        });

        //this.sidebar.querySelector('.total').innerHTML = iTotal;
    }

    update() {
        if ( this.totalItems ) {
            this.totalItems.innerHTML = '';
        }

        let sBoilerString = '';

        this.boilers.forEach(boiler => {

            sBoilerString += boiler.name;

            if ( this.zonderZorgen ) {
                sBoilerString += ` (€${boiler.dataset.priceWithContract})`;
            } else {
                sBoilerString += ` (€${boiler.dataset.price})`;
            }

        });

        this.sidebar.querySelectorAll('.onderhoudscontract, .onderhoudscontract-extra')
            .forEach(elem => {
                if (this.zonderZorgen) {
                    elem.classList.remove('hidden');
                } else {
                    elem.classList.add('hidden');
                }
                }
            );

        this.sidebar.querySelectorAll('.geen-onderhoudscontract')
            .forEach(elem => {
                if (this.zonderZorgen) {
                    elem.classList.add('hidden');
                } else {
                    elem.classList.remove('hidden');
                }
            });


        document.querySelectorAll('.show-onderhoudscontract')
            .forEach(elem => {
                if (this.zonderZorgen) {
                    elem.style.display = 'block';
                } else {
                    elem.style.display = 'none';
                }
                }
            );

        document.querySelectorAll('.show-geen-onderhoudscontract')
            .forEach(elem => {
                if (this.zonderZorgen) {
                    elem.style.display = 'none';
                } else {
                    elem.style.display = 'block';
                }
            });

        if ( this.sidebar.querySelector('.thermo_name') && this.sidebar.querySelector('.thermo_price') ) {
            if (this.newThermo) {
                if (Object.values(this.thermo).length > 0) {
                    this.sidebar.querySelector('.thermo_name').innerHTML = this.thermo.brand +' '+this.thermo.name;
                    this.sidebar.querySelector('.thermo_name').dataset.name = this.thermo.name;
                    this.sidebar.querySelector('.thermo_name').dataset.brand = this.thermo.brand;
                    this.sidebar.querySelector('.thermo_name').dataset.id = this.thermo.id;

                    this.sidebar.querySelector('.thermo_price').innerHTML = this.thermo.price;
                } else {
                    this.sidebar.querySelector('.thermo_name').innerHTML = '';
                    this.sidebar.querySelector('.thermo_price').innerHTML = '';
                }
            } else {
                this.sidebar.querySelector('.thermo_name').innerHTML = 'Bestaande thermostaat';
                this.sidebar.querySelector('.thermo_price').innerHTML = 0;
            }
        }

        const boilerInput = document.querySelector('.gfield.boilers_from_url input');
        if ( boilerInput ) {
            boilerInput.value = sBoilerString;
        }

        document.querySelectorAll('.installatie-list li')
                .forEach(item => {
                    if ( !this.zonderZorgen && item.classList.contains('installatie-zonderzorgen') ) {
                        item.classList.add('inactive');
                    } else if ( this.zonderZorgen && item.classList.contains('alleen-installatie') ) {
                        item.classList.add('inactive');
                    } else {
                        item.classList.remove('inactive');
                    }
                });

        this.calcTotal();
    }

    addEvents () {
        document.querySelectorAll('.installatie_radio input[type="radio"]')
            .forEach(radio => {
                const isChecked = radio.getAttribute('checked') === 'checked';

                radio.addEventListener('change', () => {
                    if ( isChecked ) {
                        this.zonderZorgen = true;
                    } else {
                        this.zonderZorgen = false;
                    }

                    this.update();
                })
            });

        document.querySelectorAll('.field-section.thermostaten input[type="radio"]')
            .forEach(radio => {
                radio.addEventListener('change', (evt) => {
                    const current = evt.currentTarget;
                    this.thermo = {
                        id: current.dataset.thermoId,
                        brand: current.dataset.thermoBrand,
                        name: current.dataset.thermoName,
                        price: current.dataset.thermoPrice,
                    };
                    document.querySelector('.field-section.ThermostaatId input').value = this.thermo.id;
                    this.newThermo = true;

                    this.update();
                });
            });

        const currentThermo = document.querySelector('.field-section.thermostaten input[type="radio"]:checked');
        if ( currentThermo ) {
            this.thermo = {
                id: currentThermo.dataset.thermoId,
                brand: currentThermo.dataset.thermoBrand,
                name: currentThermo.dataset.thermoName,
                price: currentThermo.dataset.thermoPrice,
            };
            document.querySelector('.field-section.ThermostaatId input').value = this.thermo.id;
            this.newThermo = true;

            this.update();
        }

        document.querySelectorAll('.field-section.Kies.uw.thermostaat input[type="radio"]')
            .forEach(radio => {
                radio.addEventListener('change', evt => {
                    if ( evt.currentTarget.value.split(',')[0] === 'Ja' ) {
                        this.newThermo = true;

                        window.setTimeout(() => {
                            window.scrollBy({
                                top: document.querySelector('.field-section.thermostaten').getBoundingClientRect().top - 30,
                                behavior: 'smooth'
                            });
                        }, 100);

                    } else {
                        this.newThermo = false;
                        this.thermo = {};
                    }

                    this.update();
                });
            });
    }
}





class fixedSidebar {
    constructor(elem) {
        const fixedHeader = document.querySelector('.main-nav-holder');
        const main = document.querySelector('#main');

        const sidebar = elem;
        if ( sidebar ) {
            //const sidebarFixed = sidebar.cloneNode(true);

            //sidebarFixed.classList.add('fixed');
            //sidebarFixed.style.top = fixedHeader.offsetHeight + 'px';
            sidebar.style.maxWidth = sidebar.parentNode.offsetWidth - 30 + 'px';

            //this.sidebarTop = sidebar.getBoundingClientRect().top;

            //sidebar.parentNode.append(sidebarFixed);

            this.originalTop = sidebar.getBoundingClientRect().top + window.pageYOffset; // - 43;
            this.fixed = false;
            this.keepScrolling = false;




            const setFixedSidebar = (evt) => {
                this.originalBottom = main.getBoundingClientRect().bottom + window.pageYOffset;
                this.headerHeight = fixedHeader.offsetHeight;
                const windowOffset = (window.pageYOffset || document.scrollTop)  - (document.clientTop || 0) || 0;
                const calculatedWindowOffset = this.headerHeight + windowOffset;
                const calculatedSidebarBottom = calculatedWindowOffset + sidebar.getBoundingClientRect().height;

                if ( this.fixed ) {
                    if ( this.originalTop > calculatedWindowOffset ) {
                        this.fixed = false;
                    }
                } else {
                    if ( this.originalTop < calculatedWindowOffset ) {
                        this.fixed = true;
                    } else {
                        this.fixed = false;
                    }
                }

                if (main) {
                    if ( this.originalBottom <= calculatedSidebarBottom ) {
                        this.keepScrolling = false;
                    } else {
                        this.keepScrolling = true;
                    }
                }

                if ( this.fixed ) {
                    sidebar.classList.add('fixed');
                    if (this.keepScrolling) {
                        sidebar.style.top = this.headerHeight + 'px';
                    } else {
                        sidebar.style.top = main.getBoundingClientRect().bottom - sidebar.getBoundingClientRect().height + 'px';
                    }
                } else {
                   sidebar.classList.remove('fixed');
                    sidebar.style.top = 0;
                }
            }



            window.addEventListener('scroll', setFixedSidebar);
            setFixedSidebar();
        }
    }
}

    new OfferteSidebar(document.querySelector('.offerte_sidebar'));
window.addEventListener('load', () => {
    document.querySelectorAll('.link-slider')
        .forEach(slider => {
            new SliderNav(slider);
        });


    new WerkgebiedTable();
    new CheckoutForm(document.querySelector('.offerte-form'));
    new FaqOverview(document.querySelector('.faq-overview'));
    new TipOverview(document.querySelector(".tip-overview"));
    new SearchTabs(
        document.querySelector('.result-tabs'),
        document.querySelectorAll('.search-result-section')
    );
    new EenmaligOnderhoudForm();
    new Overlay();
    new TableToggle();

    if ( document.querySelector('.sidebar.offerte_sidebar') ) {
        new fixedSidebar(document.querySelector('.sidebar.offerte_sidebar'));
    }

    if ( document.querySelector('.sidebar.show_total') ) {
        new fixedSidebar(document.querySelector('.sidebar.show_total'));
    }



    if ( Tawk_API && Tawk_API.getStatus ) {
        const chatIsOnline = (Tawk_API.getStatus() === "online");
        const bullet = document.querySelector('.contactgegevens .Chatten .online')
                    || document.querySelector('.contactgegevens .Chatten .offline');
        const label = document.querySelector('.contactgegevens .Chatten .beschikbaar_label')

        if ( bullet && chatIsOnline ) {
            bullet.classList.remove('offline');
            bullet.classList.add('online');
            label.innerHTML = 'Nu online';
        } else if (bullet) {
            bullet.classList.remove('online');
            bullet.classList.add('offline');
            label.innerHTML = 'Nu offline';
        }

        const link = document.querySelector('.contactgegevens .Chatten strong');
        if (chatIsOnline && link) {
            link.addEventListener('click', evt => {
                evt.preventDefault();
                Tawk_API.toggle();
            });
        }
    }



    //const mobileHeader = document.querySelector('.main-nav-holder');
    //if ( mobileHeader ) {
    //    const iMobileHeaderHeight = mobileHeader.getBoundingClientRect().height;
    //    console.log(iMobileHeaderHeight);
    //    //document.querySelector('.mobile-menu').style.marginTop = iMobileHeaderHeight +'px';
    //    //document.querySelector('body').style.paddingTop = iMobileHeaderHeight +'px';
    //}


    document.querySelectorAll('.mobile-menu .menu-item .nolink')
        .forEach(item => item.addEventListener('click', evt => {
            evt.currentTarget.nextElementSibling.click();
        }));
});





const btnToonAlles = document.querySelector('.btn-toon-alles');
if (btnToonAlles) {
    btnToonAlles.addEventListener('click', () => {
        document.querySelector('.producten').classList.toggle('full');
        document.querySelector('.btn-toon-alles').classList.toggle('open');
    });
}








const checkAddress = () => {
    window.postcodePromise = null;
    let sPostcode = '';
    let sHuisnummer = '';
    let sToevoeging = '';

    const showAddress = document.querySelector('.field-section.show_address');
    let nextBtn = null;

    if ( showAddress && showAddress.closest('.gform_page_fields') ) {
        const formFooter = showAddress.closest('.gform_page_fields').nextElementSibling || null;
        if ( formFooter ) {
            nextBtn = formFooter.querySelector('.gform_next_button');
            if (nextBtn) {
                nextBtn.disabled = true;
            }
        }
    }

    if ( document.querySelector('.field-section.Postcode input') ) {
        sPostcode = document.querySelector('.field-section.Postcode input').value;
        sPostcode = sPostcode.replace(/ /g,'');
    }

    if ( document.querySelector('.field-section.Huisnummer:not(.toevoeging) input') ) {
        sHuisnummer = document.querySelector('.field-section.Huisnummer:not(.toevoeging) input').value;
        sHuisnummer = /\d*/.exec(sHuisnummer)[0];
    }

    if ( document.querySelector('.field-section.Huisnummer.toevoeging input') ) {
        sToevoeging = document.querySelector('.field-section.Huisnummer.toevoeging input').value;
    }

    const plaatsField = document.querySelector('.field-section.Plaatsnaam input');
    const straatField = document.querySelector('.field-section.hidden.Straat input');

    if ( !/\d{4}\w{2}/.test(sPostcode) || sHuisnummer === '' ) {
        return false;
    }

    showAddress.classList.add('loading');

    const addressField = document.querySelector('.field-section.show_address');
    addressField.classList.add('active');

    const sPostcodeUrl = `${ylt.ajax_url}?action=check_postcode&postcode=${sPostcode}&huisnummer=${sHuisnummer}`;

    window.postcodePromise = fetch(sPostcodeUrl);

    window.postcodePromise
        .then(response => response.json())
        .then(oAddress => {
            if ( oAddress && document.querySelector('.field-section.show_address') ) {
                if (oAddress.street && oAddress.number && oAddress.city) {
                    const sAddress = oAddress.street +' '+ oAddress.number + sToevoeging +', '+ oAddress.city;
                    addressField.querySelector('.ginput_container input').value = sAddress;
                    addressField.querySelector('.msg').innerHTML = '';
                    if (nextBtn) {
                        nextBtn.disabled = false;
                    }

                    // Adres succesvol opgehaald
                    dataLayer.push({
                        'event': 'postcodeValidated',
                        'eventValue': "true"
                    });

                    dataLayer.push({
                        'event': 'checkoutOption',
                        'ecommerce': {
                            'checkout_option': {
                                'actionField': {'step': 1, 'option': true}
                            }
                        }
                    });
                } else {
                    addressField.querySelector('.msg').innerHTML = 'Dit adres is niet gevonden';
                    addressField.querySelector('.ginput_container input').value = '';
                    if (nextBtn) {
                        nextBtn.disabled = true;
                    }
                }

                if ( plaatsField ) {
                    plaatsField.value = oAddress.city || '';
                }

                if ( straatField ) {
                    straatField.value = oAddress.street || '';
                }
            }
        })
        .finally(() => showAddress.classList.remove('loading'));

}

document.querySelectorAll('.field-section.Postcode input, .field-section.Huisnummer input')
    .forEach(input => input.addEventListener('change', checkAddress));

window.addEventListener('load', checkAddress);





async function setupPostcodeField (holder, type, msg) {
    const postcodeInput = holder.querySelector('input')

    if ( !postcodeInput ) {
        return false;
    }

    const postcodeAlert = document.createElement('span');
    postcodeAlert.classList.add('postcode-alert');
    postcodeAlert.innerHTML = msg;
    postcodeAlert.style.display = 'none'

    const postcodeMsg = document.createElement('span');
    postcodeMsg.classList.add('postcode-msg');
    postcodeMsg.innerHTML = '<p>Uw woning bevindt zich in een stadsgedeelte met parkeerproblemen. Voor het maken van een afspraak op uw adres dient u onze monteur een vrije parkeerplaats binnen 50 meter van de woning te kunnen bieden.</p>';
    postcodeMsg.style.display = 'none'

    holder.append(postcodeAlert);
    holder.append(postcodeMsg);

    let postcodeHidden = false;
    if (holder.closest('.gform_page')) {
        postcodeHidden = holder.closest('.gform_page').style.display && holder.closest('.gform_page').style.display === 'none';
    }

    if ( postcodeInput && !postcodeHidden ) {
        const aPostcodes = await fetch(`${ylt.ajax_url}?action=get_werkgebied&type=${type}`)
                                        .then(r => r.json())
                                        .then(j => j.slice(1));

        postcodeInput.addEventListener('keyup', async evt => {
            if ( postcodeInput.value ) {
                const searchRegex = new RegExp('^'+postcodeInput.value.substr(0,4));
                const result = aPostcodes.find(row => row[0].search(searchRegex) !== -1 )

                if ( result && result[2] === 'parkeerplaats' ) {
                  postcodeMsg.classList.add('active');
                } else {
                  postcodeMsg.classList.remove('active');
                }

                if ( result ) {
                    postcodeAlert.style.display = 'none';
                } else {
                    postcodeAlert.style.display = 'block'

                    // Postcode ligt niet binnen werkgebied
                    dataLayer.push({
                        'event': 'postcodeValidated',
                        'eventValue': "false"
                    });

                    dataLayer.push({
                        'event': 'checkoutOption',
                        'ecommerce': {
                            'checkout_option': {
                                'actionField': {'step': 1, 'option': false}
                            }
                        }
                    });
                }
            } else {
                postcodeAlert.style.display = 'none'
                postcodeMsg.classList.remove('active');
            }
        });
    }
};


const postcodeHolderAlgemeen = document.querySelectorAll('.field-section.postcode-algemeen .ginput_container');
if ( postcodeHolderAlgemeen ) {
    postcodeHolderAlgemeen.forEach(elem => setupPostcodeField(elem, 'postcode-algemeen', 'Deze postcode ligt niet binnen ons werkgebied'));
}

const postcodeHolderWarmtepomp = document.querySelectorAll('.field-section.postcode-warmtepomp .ginput_container');
if ( postcodeHolderWarmtepomp ) {
    postcodeHolderWarmtepomp.forEach(elem => setupPostcodeField(elem, 'postcode-warmtepomp', 'In de door u opgegeven postcode bieden wij nog geen montage van warmtepompen aan'));
}


const postcodeHolderMontage = document.querySelectorAll('.field-section.postcode-montage .ginput_container');
if ( postcodeHolderMontage ) {
    postcodeHolderMontage.forEach(elem => setupPostcodeField(elem, 'postcode-montage', 'In de door u opgegeven postcode bieden wij nog geen montage aan'));
}








document.querySelectorAll('[data-active-option]')
    .forEach(section => {
        const iActiveIndex = parseInt(section.dataset.activeOption);
        section.querySelectorAll('li').
            forEach( (li,index) => {
                if ( index == iActiveIndex ) {
                    li.querySelector('input').checked = 'checked';
                } else {
                    li.querySelector('input').checked = '';
                }
            });
    });




//document.querySelector('.gform_wrapper').closest('#main').classList.add('form-parent');



if ( document.querySelector('.onze-werkwijze-link') ) {
    document.querySelector('.onze-werkwijze-link')
            .addEventListener('click', () => {
                const mainNavHeight = document.querySelector('.main-nav-holder')
                                              .getBoundingClientRect().height;

                if ( $('.onze-werkwijze') ) {
                    $('html, body').animate({
                        scrollTop: $('.onze-werkwijze').offset().top - mainNavHeight
                    });
                }
            });
}







const thermoInput = document.querySelector('.field-section.thermostaten .ginput_container input[type="text"]');

if ( thermoInput ) {
    document.querySelectorAll('.thermo-options input[type="radio"]')
        .forEach(input =>
            input.addEventListener('change', evt => {
                thermoInput.value = evt.currentTarget.value;
            }));
}










function findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
    return result;
}

// Geen thermostaten bij meerdere boilers
if ( findGetParameter('fe-cvketel') ) {
    if ( JSON.parse(findGetParameter('fe-cvketel')).length > 1 ) {
        const thermoElem = document.querySelector('.gfield:empty');
        thermoElem.previousSibling.style.display = 'none';
    }
}







const klantenVertellen = document.querySelector('.klanten-vertellen-toon-alles')
if (klantenVertellen) {
    klantenVertellen
        .addEventListener('click', evt => {
            evt.currentTarget.style.display = 'none';
            document.querySelector('.klanten-vertellen .reviews-container')
                .classList.add('show-all');
        });
}






window.addEventListener('DOMContentLoaded', () => {
    const getParameters = [
        {
            name: 'Onderhoud',
            param: 'freq',
        },
        {
            name: 'Arbeidslonen',
            param: 'v_en_a',
        },
        {
            name: 'Onderdelen',
            param: 'ketel_onderdelen',
        },
    ];

    getParameters
        .forEach(parameter => {
            const input = document.querySelector(`input[type="hidden"][name="get_${parameter.param}"]`);
            if ( input && input.value && input.value != 0 ) {
                document.querySelector(`.field-section.${parameter.name} .gfield_radio li:nth-child(${input.value}) input`).checked = true;
                console.log(document.querySelector(`.field-section.${parameter.name} .gfield_radio li:nth-child(${input.value}) input`));
            }
        });

    document.querySelectorAll(`.field-section.Extras .gfield_radio li`)
        .forEach( (elem, index) => {
            if ( index == 0 ) {
                const input = document.querySelector(`input[type="hidden"][name="get_vent_box"]`);
                if ( input && input.value && input.value != 0 ) {
                    elem.querySelector('input').checked = true;
                }

            } else if ( index == 1 ) {
                const input = document.querySelector(`input[type="hidden"][name="get_wtw_unit"]`);
                if ( input && input.value && input.value != 0 ) {
                    elem.querySelector('input').checked = true;
                }
            }
        });
});








const filterCheckboxes = document.querySelectorAll('.merkFilterCheckbox, .productlineFilterCheckbox');
const productlineCheckboxes = document.querySelectorAll('.productlineFilterCheckbox');
const productLineGroup = document.querySelector('.filter-group.productline');

function showProductlineFilters () {
    const merkSelected = [...filterCheckboxes]
        .filter(checkbox => checkbox.checked)
        .map(checkbox => checkbox.value);

    productlineCheckboxes
        .forEach(checkbox => {
            if ( merkSelected.indexOf(checkbox.dataset.merken) !== -1 ) {
                checkbox.nextElementSibling.style.display = 'block';
            } else {
                checkbox.nextElementSibling.style.display = 'none';
            }
        });

    if ( productLineGroup ) {
        if ( merkSelected.length > 0 ) {
            productLineGroup.classList.add('visible');
        } else {
            productLineGroup.classList.remove('visible');
        }
    }
}

filterCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', showProductlineFilters);
});

window.addEventListener('DOMContentLoaded', showProductlineFilters);











const storingOplossenForm = document.querySelector('form.storing-oplossen');



const showDescription = function ({merk = null, type = null, code = null} = {}) {
    storingOplossenForm.querySelectorAll('.description').forEach(elem => elem.style.display = 'none');

    if ( merk && type && code ) {
        const selectedDescription = storingOplossenForm.querySelector(`.description.${merk}.${type}.code-${code}`);

        if ( selectedDescription ) {
            selectedDescription.style.display = 'block';
        }
    }
};

const showCodeSelect = function ({merk = null, type = null} = {}) {
    storingOplossenForm.querySelectorAll('select.code').forEach(elem => elem.style.display = 'none');

    if ( merk && type ) {
        const codeSelect = storingOplossenForm.querySelector(`select.code.${merk}.${type}`);
        codeSelect.value = '';
        codeSelect.style.display = 'block';

        if ( codeSelect ) {

            showDescription({merk, type, code: codeSelect.value});
            codeSelect.addEventListener('change', () => {
                showDescription({merk, type, code: codeSelect.value});
            });
        }
    } else {
        storingOplossenForm.querySelector('select.code[disabled]').style.display = 'block';
        showDescription();
    }
};

const showTypeSelect = function ({merk = null} = {}) {
    storingOplossenForm.querySelectorAll('select.type').forEach(elem => elem.style.display = 'none');

    if ( merk ) {
        const typeSelect = storingOplossenForm.querySelector(`select.type.${merk}`);
        typeSelect.value = '';
        typeSelect.style.display = 'block';

        if ( typeSelect ) {

            showCodeSelect({merk, type: typeSelect.value });
            typeSelect.addEventListener('change', () => {
                showCodeSelect({merk, type: typeSelect.value });
            });
        }
    } else {
        storingOplossenForm.querySelector('select.type[disabled]').style.display = 'block';
        showCodeSelect();
    }
};


if ( storingOplossenForm ) {
    const merkSelect = storingOplossenForm.querySelector('select.merk');
    showTypeSelect({merk: merkSelect.value});
    merkSelect.addEventListener('change', () => {
        showTypeSelect({merk: merkSelect.value});
    });
}







// Open persoonlijk advies
const downloadBrochureBtn = document.querySelector('.download-brochure-btn');
const persoonlijkAdviesBtn = document.querySelector('.overlay-button-persoonlijk-advies');

if ( downloadBrochureBtn && persoonlijkAdviesBtn ) {
    downloadBrochureBtn
        .addEventListener('click', evt => {
            persoonlijkAdviesBtn.click();
        });
}







// Professionals
const filters = document.querySelectorAll('.block.type-professionals .filters');
const categoryButtons = document.querySelectorAll('.block.type-professionals .filter-categories button');
const filterInputs = document.querySelectorAll('.block.type-professionals .filters input');
const professionals = [...document.querySelectorAll('.block.type-professionals .professional')]
                        .map(elem => {
                            return {
                                elem,
                                category: JSON.parse(elem.dataset.category),
                            };
                        });

function setProfessionalsFilter () {
    const button = document.querySelector('.block.type-professionals .filter-categories button.selected');

    const categories = [...filterInputs]
        .filter(input => input.checked)
        .map(input => parseInt(input.dataset.id));

    professionals.forEach(prof => {
        prof.elem.classList.add('inactive');
    });

    if ( categories.length > 0 ) {
        professionals.forEach(prof => {
            if ( prof.category.some(category => categories.includes(category)) ) {
                prof.elem.classList.remove('inactive');
            }
        });
    } else {
        if ( button.dataset.type ) {
            professionals.forEach(prof => {
                if ( prof.elem.dataset.type === button.dataset.type ) {
                    prof.elem.classList.remove('inactive');
                }
            });
        } else {
            professionals.forEach(prof => {
                prof.elem.classList.remove('inactive');
            });
        }
    }
}

categoryButtons
    .forEach(btn => btn.addEventListener('click',
        evt => {
            categoryButtons.forEach(elem => elem.classList.remove('selected'));
            btn.classList.add('selected');

            const type = btn.dataset.type;
            filters.forEach(elem => elem.classList.remove('active'));

            [...filters]
                .map(elem => {
                    elem.querySelectorAll('input').forEach(input => input.checked = false);
                    return elem;
                })
                .filter(elem => elem.classList.contains(type))
                .map(elem => {
                    elem.classList.add('active');
                });

            setProfessionalsFilter();
        })
    );

filterInputs
    .forEach(input => input.addEventListener('change', setProfessionalsFilter));






const notification = document.querySelector('.notification');
if ( notification ) {
    const close = notification.querySelector('.close-btn');

    close.addEventListener('click', () => {
        window.Cookies.set('notification-hidden', 'true');
        notification.remove();
    });
}





const uspSlider = document.querySelector('.usp-list.slider');
const uspSliderItems = document.querySelectorAll('.usp-list.slider .usp-item');
if ( uspSlider ) {
    let counter = 0;

    const delay = 5000;

    const slideCount = uspSliderItems.length;
    const slideWidth = 100 / slideCount;

    function nextSlide () {
        counter++;
        if ( counter >= slideCount ) counter = 0;

        const translate = slideWidth * counter;
        uspSlider.style.translate = `-${translate}% 0`;

        return window.setTimeout(nextSlide, delay);
    }

    window.setTimeout(nextSlide, delay);
}






function scrollToElem(elem) {
    if ( !elem ) return false;

    const mainNavHolder = document.querySelector('.main-nav-holder');
    const headerHeight = mainNavHolder.offsetHeight;
    console.log(headerHeight);

    window.scrollBy({
        top: elem.getBoundingClientRect().top - headerHeight,
        behavior: 'smooth'
    });
}

window.addEventListener('load', () => {
    const ketelTitle = document.querySelector('.ons-aabod-title');
    scrollToElem(ketelTitle);
});






const ratingStars = document.querySelectorAll('.set-rating .star');
if ( ratingStars ) {

    function setStarRatingFull (end) {
        ratingStars.forEach(star => star.classList.remove('full'));

        ratingStars.forEach((star,index) => {
            if ( index <= end ) {
                star.classList.add('full');
            }
        });
    }

    function setupRatingFromSelected () {
        const index = [...ratingStars]
            .findIndex(s => s.querySelector('input:checked'));

        if ( index  === -1 ) {
            setStarRatingFull(-1);
        } else {
            setStarRatingFull(index);
        }
    }

    setupRatingFromSelected();

    ratingStars
        .forEach((star, index) => {
            star.addEventListener('mouseover', () => {
                setStarRatingFull(index);
            });

            star.addEventListener('mouseleave', setupRatingFromSelected);

            star.querySelector('input')
                .addEventListener('change', () => {
                    setStarRatingFull(index);
                });
        });
}



const ratingForm = document.querySelector('.rating-form');
const ratingInputs = document.querySelectorAll('.rating-form input, .rating-form textarea');

if ( ratingForm && ratingInputs ) {
    const ratingFields = ['rating', 'name', 'city', 'message'];

    function validateForm () {
        const formData = [...new FormData(ratingForm)];
        const submitButton = ratingForm.querySelector('.submit-holder button.submit-review:not(.disabled)');
        const submitButtonDisabled = ratingForm.querySelector('.submit-holder button.submit-review.disabled');

        const valid = ratingFields
            .every(field =>
                formData.find(
                    ([key, value]) => field == key && value
                )
            );

        if ( valid ) {
            submitButton.classList.remove('d-none');
            submitButtonDisabled.classList.add('d-none');
        } else {
            submitButton.classList.add('d-none');
            submitButtonDisabled.classList.remove('d-none');
        }
    }

    validateForm();

    ratingInputs
        .forEach(input => {
            input.addEventListener('change', validateForm);
            input.addEventListener('keyup', validateForm);
        });


    const ratingsHolder = document.querySelector('.rating-holder .ratings');
    const showMoreBtn = document.querySelector('.show-all-reviews-btn');
    if ( ratingsHolder && showMoreBtn ) {
        showMoreBtn.addEventListener('click', () => {
            ratingsHolder.classList.add('show-all');
            showMoreBtn.style.display = 'none';
        });
    }
}






window.addEventListener('DOMContentLoaded', () => {

  if (!window.gform)  return;

  gform.addFilter( 'gform_datepicker_options_pre_init', function( optionsObj, formId, fieldId ) {

        optionsObj.selectOtherMonths = true;

        if ( formId == 11 ) {
            optionsObj.minDate = 0;
        }

        const field = document.querySelector('#input_'+formId +'_'+ fieldId);

        if ( field !== null ) {
            const fieldSection = field.parentElement.parentElement;

            if ( fieldSection ) {
                if ( fieldSection.dataset.weeksUntil && fieldSection.dataset.weeksUntil != 0 ) {
                    const weeksUntil = parseInt(fieldSection.dataset.weeksUntil) + 1;
                    const now = new Date();
                    const next4Weeks = new Date(now.getFullYear(), now.getMonth(), now.getDate() + (7 * weeksUntil) - now.getDay() + 1);

                    optionsObj.minDate = next4Weeks;
                }

                if ( fieldSection.dataset.showWeekends ) {
                    if ( fieldSection.dataset.showWeekends == 'false' ) {
                        optionsObj.firstDay = 1;
                        optionsObj.beforeShowDay = jQuery.datepicker.noWeekends;
                    }
                }

                if ( fieldSection.dataset.dateUntil ) {
                    optionsObj.maxDate = new Date(fieldSection.dataset.dateUntil);
                }
            }
        }



        if ( field !== null ) {
            const fieldSection = field.parentElement.parentElement;

            if ( fieldSection.classList.contains('date-mon-fri') ) {
                const now = new Date();
                const next4Weeks = new Date(now.getFullYear(), now.getMonth(), now.getDate() + (7 * 5) - now.getDay());

                optionsObj.minDate = next4Weeks;
                optionsObj.firstDay = 1;
                optionsObj.beforeShowDay = jQuery.datepicker.noWeekends;
            }
        }

        return optionsObj;
    } );
});





const hamburger = document.querySelector('#hamburger');
const navContainer = document.querySelector('.nav-container');

if ( hamburger && navContainer ) {
  navContainer
    .querySelectorAll('.menu-item:has(.sub-menu)')
    .forEach(menuItem => {
      const subMenu = menuItem.querySelector('.sub-menu');
      const toggleBtn = document.createElement('button');
      toggleBtn.classList.add('toggle');
      toggleBtn.innerHTML = 'Toggle';

      toggleBtn.addEventListener('click', () => {
        menuItem.classList.toggle('sub-menu-open');
      });

      subMenu.before(toggleBtn);
    });
}
